<script setup>
import {computed, onMounted, ref} from "vue";
import {couponConf} from "@/utils/config";
import store from "@/store";
import XmLogin from "@/components/login/xmLogin.vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";

const types = computed(() => {
  return couponConf["tm-xmair"]
})
const coupon = computed(() => {
  return store.state.product
})
const account = computed(() => store.state.account)
const tm_account = ref("")
onMounted(() => {
  store.commit('getCouponIts')
  store.dispatch("getAccounts")
  store.commit("getOrderFrom")
  document.title = coupon.value?.goods_name
})
const product_show_drawer = ref(false)
const showLogin = ref(false)
const payLoading = ref(false)
const login = () => {
  showLogin.value = false
  if (Object.keys(account.value).length > 0) {
    product_show_drawer.value = true
  }
}

const payment = () => {
  if (tm_account.value.length < 1) {
    return ElMessage.error("请输入淘宝账号！");
  }
  if (parseFloat(account.value.balance_miles) < parseFloat(coupon.value.mileTypes?.[types.value.login]?.total)) {
    return ElMessage.error("可用积分不足！");
  }
  payLoading.value = true
  new axiosApi({
    encode: "coupon",
    method: "life/pay",
    body: {
      plate: coupon.value.from_items,
      product: coupon.value.third_id,
      type: types.value.login,
      cust_id: account.value.cust_id,
      account: tm_account.value,
      access_token: account.value.access_token || "",
      user_id: account.value.user_id || "",
      order_from: store.state.orderFrom
    }
  }).send((res) => {
    payLoading.value = false
    product_show_drawer.value = false
    if (res.message.code !== "000") {
      return ElMessage.error({message: res.message.content})
    }
    window.location.href = res.data.transUrl
  }, () => payLoading.value = false)
}
</script>

<template>
  <el-scrollbar class="tm-detail">
    <div class="tm-coupon-images">
      <el-image src="https://images.jifen360.com/tm_mark/card.png"/>
      <div class="tm-face-value">
        <span class="tm-face-money">{{ parseFloat(coupon?.face_value) }}</span><span class="tm-face-unit">元</span>
      </div>
    </div>
    <div class="product-info">
      <h4>{{ coupon?.goods_name }}
        <el-text type="warning" size="small" style="padding-left: 15px">官方直充</el-text>
      </h4>
      <div class="tm-face-value">
        <el-text type="danger" class="tm-face-money">
          {{ parseFloat(coupon?.mileTypes?.[types?.login]?.total) }}
        </el-text>
        <el-text type="info" class="tm-face-unit">{{ types?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
      </div>
    </div>
    <div class="product-recharge-items">
      <div class="recharge-title">
        <b>天猫超市卡兑换须知</b>
      </div>
      <ol class="recharge-content">
        <li>使用规则：此卡为一次性使用，一经兑换，不可退换、转售、兑现、拆分使用，不可赠送他人使用；</li>
        <li>
          本超市卡为直充产品，
          <el-text type="danger"><b>兑换时请填写正确的淘宝账号，请勿填写账号绑定的手机号、邮箱、淘宝昵称等;</b></el-text>
          因淘宝账号填写错误造成的损失由会员本人承担；
        </li>
        <li>淘宝会员名查看方法:打开淘宝APP-我的淘宝-设置-账户与安全-淘宝账号；</li>
        <li>使用和查看:本超市卡至充值之日起有效期3年，仅限于在天猫超市中购物付款时使用，不记名、不挂失、不兑现，请妥善保管；
        </li>
        <li>如遇超市卡不能正常兑换或使用，请拨打服务热线:4000-360-195。</li>
      </ol>
      <div class="recharge-title">
        <b>天猫超市卡使用说明</b>
      </div>
      <ol class="recharge-content">
        <li>超市卡可分次使用，订单金额超过超市卡余额时，不足部分消费金额请通过天猫超市支持的支付方式补齐；</li>
        <li>超市卡在天猫超市通用，含量版装、生鲜区、各类折扣区，但不支持运费抵扣；</li>
        <li>使用超市卡购物不开具发票；</li>
        <li>本平台仅是提供会员与商户之间的兑换服务平台，如遇商品质量问题，请及时与商户联系。</li>
      </ol>
    </div>
  </el-scrollbar>
  <div class="tm-recharge-btn">
    <el-button round type="danger" v-if="Object.keys(account).length < 1" @click="showLogin=true">立即兑换</el-button>
    <el-button round type="danger"
               v-else-if="Object.keys(account).length && parseInt(account.balance_miles) > parseFloat(coupon?.mileTypes?.[types?.login]?.total)"
               @click="product_show_drawer=true">立即兑换
    </el-button>
    <el-button round type="danger" v-else disabled>可用{{ types?.login === 'xm_air' ? '积分' : '里程' }}</el-button>
  </div>
  <el-drawer v-model="product_show_drawer" size="450px" direction="btt" :show-close="false" class="product-drawer">
    <template #header>
      <div class="product-drawer-header">
        <div class="product-drawer-logo">
          <el-image src="https://images.jifen360.com/tm_mark/tm-log.png"/>
        </div>
        <div class="product-drawer-items">
          <h4>{{ coupon?.goods_name }}</h4>
          <el-text type="info">电子兑换券</el-text>
          <div class="tm-face-value">
            <el-text type="danger" class="tm-face-money">{{
                parseFloat(coupon?.mileTypes?.[types?.login]?.total)
              }}
            </el-text>
            <el-text type="info" class="tm-face-unit">{{ types?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <div class="coupon-tips">
      <div>
        注意事项：兑换时请<span class="coupon-tips-tag">填写正确的淘宝账号，</span>
      </div>
      <div style="color: #EC6344">
        请勿填写账号绑定的手机号、邮箱、淘宝昵称等
      </div>
      <div style="white-space: nowrap">
        账号查看方法：
        <span class="coupon-tips-tag">打开淘宝APP-我的淘宝-设置-账户与安全-淘宝账号</span>
      </div>
    </div>
    <el-card class="product-card" shadow="never">
      <div class="product-item-lst">
        <div class="product-item-label">淘宝账号</div>
        <div class="product-item-value">
          <el-input placeholder="请输入淘宝账号" v-model="tm_account"/>
        </div>
      </div>
    </el-card>
    <el-card class="product-card" shadow="never">
      <div class="product-item-lst">
        <div class="product-item-label">
          可用{{ types?.login === 'xm_air' ? '积分' : '里程' }}
        </div>
        <div class="product-item-value">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="product-item-lst">
        <div class="product-item-label">
          支付{{ types?.login === 'xm_air' ? '积分' : '里程' }}
        </div>
        <div class="product-item-value">
          {{ coupon?.mileTypes?.[types?.login]?.total }}
        </div>
      </div>
    </el-card>
    <div class="product-btn">
      <el-button round type="danger" @click="payment" :loading="payLoading">立即兑换</el-button>
    </div>
  </el-drawer>
  <xm-login :show-login="showLogin" v-if="showLogin && types.login === 'xm_air'" @login="login"/>
</template>

<style scoped lang="less">
.tm-detail {
  height: calc(100vh - 65px);
  box-sizing: border-box;
  padding: 15px;

  .tm-coupon-images {
    position: relative;

    .tm-face-value {
      position: absolute;
      left: 15px;
      bottom: 50px;
      font-weight: 600;
      color: #4A8429;
      display: flex;
      align-items: flex-end;

      .tm-face-money {
        font-size: 1.32rem;
        margin-top: 5px;
      }

      .tm-face-unit {
        margin-bottom: 3px;
        font-size: .8rem;
      }
    }
  }

  .product-info {
    line-height: 1.45;
    margin-bottom: 15px;

    .el-text--warning {
      color: #EF903E !important;
    }

    .tm-face-value {
      .tm-face-money {
        font-size: 1.62rem;
        margin-top: 5px;
      }

      .tm-face-unit {
        font-size: .8rem;
      }
    }
  }

  .product-recharge-items {
    box-sizing: border-box;
    padding: 10px 15px;
    background: #F2FEE2;
    border-radius: 12px;

    .recharge-title {
      font-size: .9rem;
      color: #EA4A2C;
      margin-bottom: 10px;
    }

    .recharge-content {
      line-height: 1.7;
      font-size: .75rem;
      padding-left: 15px;
      text-align: justify-all;
      margin-bottom: 15px;

      .el-text--danger {
        color: #EA4A2C;
        font-size: .75rem;
      }
    }
  }
}

.tm-recharge-btn {
  box-shadow: 0 0 3px rgba(0, 0, 0, .1);
  height: 65px;
  box-sizing: border-box;
  padding: 15px;
  text-align: center;

  .el-button {
    width: 98%;
  }
}

.product-drawer-header {
  display: flex;
  align-items: center;

  .product-drawer-logo {
    width: 100px;
    flex-basis: 100px;
    height: 80px;
    border-radius: 10px;
    background: #6DC43D;
    position: relative;
    margin-right: 5px;

    .el-image {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 10px;
      right: 10px;
    }
  }

  .product-drawer-items {
    line-height: 1.4;

    .tm-face-money {
      font-size: 1.62rem;
      margin-top: 5px;
    }

    .tm-face-unit {
      font-size: .8rem;
    }
  }
}

.coupon-tips {
  margin-top: -15px;
  font-size: .7rem;
  line-height: 1.7;

  .coupon-tips-tag {
    padding: 0 5px;
    background: #EC6344;
    color: #ffffff;
    display: inline-block;
    margin-left: 5px;
    border-radius: 3px;
  }
}

.product-card {
  margin: 15px 0;
  border-radius: 8px;

  .product-item-lst {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & + .product-item-lst {
      margin-top: 10px;
      padding-top: 10px;
      border-top: var(--el-border);
    }

    .product-item-label {
      width: 120px;
      flex-basis: 120px;
    }

    .product-item-value {
      width: calc(100% - 120px);
      text-align: right;
    }
  }
}

.product-btn {
  width: 98%;
  margin: auto;

  .el-button {
    width: 100%;
  }
}
</style>